import i18n from 'modules/core/lib/i18n'

export const getCardPeriodOptions = () => [
  {
    label: i18n.t('common.monthly'),
    value: 'monthly',
  },
  {
    label: i18n.t('common.yearly'),
    value: 'yearly',
  },
]

export const flexibilityOptions = [
  {
    value: 5,
  },
  {
    value: 10,
  },
  {
    value: 20,
  },
  {
    value: 30,
  },
]
